module.exports = __webpack_public_path__ + "img/logo_en.f372c3f8.png";